import { render, staticRenderFns } from "./usuario.vue?vue&type=template&id=98883a86"
import script from "./usuario.vue?vue&type=script&lang=js"
export * from "./usuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports